<template>
  <div>
    <el-dropdown trigger="click" class="user-avatar" @command="handle">
      <div>
        <el-avatar size="small" icon="el-icon-user-solid"></el-avatar>
      </div>
      <el-dropdown-menu slot="dropdown" class="logout">
        <el-dropdown-item command="logout">
          Logout
        </el-dropdown-item>
        <el-dropdown-item command="changePassword">
          Change Password
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <el-dialog
      :visible.sync="passwordDialogVisible"
      width="620px"
      append-to-body
      :close-on-click-modal="false"
      :before-close="handlePasswordClose"
      title="Change password"
    >
      <div style="margin-top: 15px;"></div>
      <el-form
        :label-position="'left'"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="150px"
        :model="ruleForm"
      >
        <el-form-item label="Account:">
          <span>{{ userInfo.name || '' }}</span>
        </el-form-item>
        <el-form-item label="Current Password:" prop="oldPassword">
          <el-input
            type="password"
            v-model="ruleForm.oldPassword"
            placeholder="Input"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="New Password:" prop="newPassword">
          <el-input
            type="password"
            v-model="ruleForm.newPassword"
            placeholder="Input"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="Confirm Password:" prop="retypePassword">
          <el-input
            type="password"
            v-model="ruleForm.retypePassword"
            placeholder="Input"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('ruleForm')">Reset</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitForm('ruleForm')">Save</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { resetPassword } from '@/api/login'

const passwordReg = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,}$/

export default {
  data() {
    const validateNewPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter the new password.'))
      } else if (!passwordReg.test(value)) {
        callback(new Error('Must be 8+ characters with upper/lowercase letters, numbers, and symbols.'))
      } else {
        callback()
      }
    }
    const validateRetypePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please confirm password.'))
      } else if (value !== this.ruleForm.newPassword) {
        callback(new Error('New password and Confirm password mismatch!'))
      } else {
        callback()
      }
    }
    const validateOldPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter your current password.'))
      } else {
        callback()
      }
    }
    return {
      passwordDialogVisible: false,
      submitLoading: false,
      ruleForm: {
        oldPassword: '',
        newPassword: '',
        retypePassword: ''
      },
      rules: {
        oldPassword: [
          { validator: validateOldPassword, trigger: 'blur' }
        ],
        newPassword: [
          { validator: validateNewPassword, trigger: 'blur' }
        ],
        retypePassword: [
          { validator: validateRetypePassword, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    handle(type) {
      if (type === 'changePassword') {
        this.passwordDialogVisible = true
        this.$nextTick(() => {
          this.resetForm('ruleForm')
        })
        return
      }
      this.$store.dispatch('user/logout', type)
    },
    handlePasswordClose(done) {
      this.passwordDialogVisible = false
      done()
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return
        this.submitLoading = true
        resetPassword({
          oldPassword: this.ruleForm.oldPassword,
          newPassword: this.ruleForm.newPassword
        })
          .then((res) => {
            this.$message.success(res.message || 'Success')
            this.passwordDialogVisible = false
          })
          .catch(() => {})
          .finally(() => {
            this.submitLoading = false
          })
      })
    },
    resetForm(formName) {
      this.$refs[formName] && this.$refs[formName].resetFields()
    }
  }
}
</script>
